/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const samplePlateRouter = {
  path: '/samplePlate',
  component: Layout,
  name: 'samplePlate',
  redirect: '/samplePlate',
  hidden: false,
  meta: {
    title: '样板管理'
  },
  children: [
    {
      path: '/samplePlate',
      component: () => import('@/views/samplePlate/index'),
      name: 'samplePlate',
      meta: { title: '样板管理', affix: true, projectId: 100 }
    }
  ]
}

export default samplePlateRouter